$(document).ready(function () {


    document.querySelectorAll('[data-slider-config]').forEach(slider => {
      const config = JSON.parse(slider.dataset.sliderConfig);

      if (!$(slider).hasClass('slick-initialized')) {
        $(slider).slick(config);
      }
    });

});

 $(document).on("click", ".hk-play-button", function (e) {
     var video = jQuery(this).parents('.hk-video-wrapper').find('video');
 if (jQuery(this).hasClass("hk-active")) {
    jQuery(this).parents('.hk-video-wrapper').removeClass('hk-active');
     jQuery(this).removeClass('active');
 video.trigger('pause');
 } else {
 video.trigger('play');
   jQuery(this).parents('.hk-video-wrapper').addClass('hk-active');
     jQuery(this).addClass('hk-active');
 }
 });



 
jQuery(document).ready(function(){
if(navigator.userAgent.indexOf('Mac') > 0) {
jQuery('body').addClass('mac-os');
} else {
jQuery('body').addClass('window-os');
}
});

$(window).on('scroll', function () {
  let scrollTop = $(this).scrollTop();

  if (scrollTop > 30) {
    $('body').addClass('remove_transparent');
  } else {
    $('body').removeClass('remove_transparent');
  }
});



$(document).on("click", ".hk-question", function (e) {
  if (jQuery(this).hasClass("hk-active")) {
    jQuery(this).toggleClass('hk-active');
    jQuery(this).next().slideToggle();
  } else {
    jQuery('.hk-question').removeClass('hk-active');
    jQuery('.hk-question').next().slideUp();
    jQuery(this).toggleClass('hk-active');
    jQuery(this).next().slideToggle();
  }
});


$(document).on("click", "a[href='/#faq']", function (e) {
  const target = document.querySelector('.hk-faq');

  if (target) {
    e.preventDefault();
    target.scrollIntoView({
      behavior: 'smooth'
    });
  }
  // else: do nothing → browser follows the link normally
});
$(document).on("click", "a[href='#reviews']", function (e) {
  e.preventDefault();
  document.querySelector('#reviews').scrollIntoView({
    behavior: 'smooth'
  })
});

$(document).on("click", ".hk-mobile-menu-button", function (e) {
    $('.hk-drawer-menu').addClass('active');
    $('.hk-drawer-menu-bg').show();
    $('body').addClass('hk-overflow-hidden');
});
$(document).on("click", ".hk-mobile-menu-close", function (e) {
    $('.hk-drawer-menu').removeClass('active');
    $('.hk-drawer-menu-bg').hide();
    $('body').removeClass('hk-overflow-hidden');
});

$(document).on("click", ".hk-drawer-menu-bg", function (e) {
    $('.hk-drawer-menu').removeClass('active');
    $('.hk-drawer-menu-bg').hide();
    $('body').removeClass('hk-overflow-hidden');
});




$(document).on("click", ".hk-element-option", function(e) {
$(this).parents('.hk-product').find('.hk-element-option').removeClass('active');
$(this).addClass('active');
var data_tab = $(this).attr('data_tab');
$(this).parents('.hk-product').find('.hk-quantity-data').hide();
$(this).parents('.hk-product').find('.hk-quantity-data[data_tab="'+data_tab+'"]').show();
});


$(document).on("click", ".hk-sub-toggle.active", function(e) {
$(this).removeClass('active');
var sub_tab = 1;
$(this).parents('.hk-product').find('.hk-sub-tab').hide();
$(this).parents('.hk-product').find('.hk-sub-tab[sub_tab="'+sub_tab+'"]').show();
});

$(document).on("click", ".hk-sub-toggle:not(.active)", function(e) {
$(this).addClass('active');
var sub_tab = 2;
$(this).parents('.hk-product').find('.hk-sub-tab').hide();
$(this).parents('.hk-product').find('.hk-sub-tab[sub_tab="'+sub_tab+'"]').show();
});











$(document).on("click", ".hk-cart-button", function (e) {
    location.href="/cart";
});





function getReviewSelector() {
    return window.matchMedia("(max-width: 767px)").matches
        ? '.hk-pdp-review2-list1-item:nth-child(4)~.hk-pdp-review2-list1-item'
        : '.hk-pdp-review2-list1-item:nth-child(6)~.hk-pdp-review2-list1-item';
}

$(document).on("click", "a[href='#show_more']", function (e) {
    e.preventDefault();

    $(getReviewSelector()).slideDown();
    $('.hk-pdp-review2-read-more:has(a[href="#show_more"])').hide();
    $('.hk-pdp-review2-read-more:has(a[href="#show_less"])').show();
});

$(document).on("click", "a[href='#show_less']", function (e) {
    e.preventDefault();

    $(getReviewSelector()).slideUp();
    $('.hk-pdp-review2-read-more:has(a[href="#show_less"])').hide();
    $('.hk-pdp-review2-read-more:has(a[href="#show_more"])').show();
});


$(document).on('click', '.hk-plus-btn, .hk-minus-btn', function () {
    const $wrapper = $(this).closest('.hk-quantity');
    const $input = $wrapper.find('.hk-quantity-input');

    let value = parseInt($input.val(), 10) || 1;
    const min = parseInt($input.attr('min'), 10) || 1;
    const max = parseInt($input.attr('max'), 10) || Infinity;

    if ($(this).hasClass('hk-plus-btn') && value < max) {
        value++;
    }

    if ($(this).hasClass('hk-minus-btn') && value > min) {
        value--;
    }

    $input.val(value).trigger('change');
});

$(document).on('change input', '.hk-quantity-input', function () {
    const $input = $(this);
    const $wrapper = $input.closest('.hk-quantity');

    const min = parseInt($input.attr('min'), 10) || 1;
    const max = parseInt($input.attr('max'), 10) || Infinity;

    let value = parseInt($input.val(), 10) || min;

    value = Math.max(min, Math.min(max, value));

    $input.val(value);

    $wrapper.find('.hk-minus-btn').prop('disabled', value <= min);
    $wrapper.find('.hk-plus-btn').prop('disabled', value >= max);
    var quantity = value;
$(this).parents('.hk-product').find('.hk-quantity-trigger').hide().removeClass('hk-active');
$(this).parents('.hk-product').find('.hk-quantity-trigger[quantity="'+quantity+'"]').show().addClass('hk-active');
$(this).parents('.hk-product').find('.hk-checkout-button').attr('quantity',quantity);
});



$(document).on('change', '.hk-variant-selector', function () {
var variant_id  = $(this).val();
$(this).parents('.hk-product').find('.hk-variant-trigger').hide().removeClass('hk-active');
$(this).parents('.hk-product').find('.hk-variant-trigger[variant_id="'+variant_id+'"]').show().addClass('hk-active');
$(this).parents('.hk-product').find('.hk-checkout-button').attr('variant_id',variant_id);
});

$(document).on('change', '.hk-card-variant-selector', function () {
$(this).closest('.hk-icon-with-text-flex').find('.hk-atc-js').attr('variant_id', $(this).val());
});





$(document).on("click", ".hk-pdt-size p em", function(e) {
$('.hk-popup.hk-size-popup').addClass('hk-active');
});


$(document).on("click", ".hk-close-popup", function(e) {
$('.hk-popup').removeClass('hk-active');
});

$(document).on("click", ".hk-scroll-right", function(e) {
$('.hk-size-img').animate({scrollLeft: '+=200'}, 250);
});
$(document).on("click", ".hk-scroll-left", function(e) {
$('.hk-size-img').animate({scrollLeft: '-=200'}, 250);
});






  $(document).on("click", '.hk-atc-js', function (e) {
  e.preventDefault();
  var $btn = $(this);
  // prevent multiple clicks
  if ($btn.hasClass('hk-loading')) return;

  $btn.addClass('hk-loading');

  var items = [];
  var variant_id = $btn.attr('variant_id');
  var selling_plan = $btn.attr('selling_plan');
  var quantity = $btn.attr('quantity');
  var item = {
    id: parseInt(variant_id),
    quantity: quantity
  };
  // add selling plan if exists
  if (selling_plan) {
    item.selling_plan = parseInt(selling_plan);
  }

  items.push(item);
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: JSON.stringify({
      items: items
    }),
    dataType: 'json',
    contentType: 'application/json',

    success: function () {

    },

    complete: function () {
      setTimeout(function () {
        $btn.removeClass('hk-loading');
        location.href="/cart";
      }, 10);
    }
  });

});
/* mobile drawer: expand a menu item's children in place */
document.addEventListener('click', function (e) {
  var btn = e.target.closest('.hk-drawer-menu-content .hk-menu-toggle');
  if (!btn) return;

  e.preventDefault();
  var item = btn.closest('.hk-menu-item');
  var open = item.classList.toggle('is-open');
  btn.setAttribute('aria-expanded', open ? 'true' : 'false');
});
